module.exports = __webpack_public_path__ + "static/media/hockey-puck.5cf1afdf.svg";